export default __webpack_public_path__ + "static/media/atome_banner_Cn.59c26dd8.webp";